module.exports = __webpack_public_path__ + "img/sashimiseitlich.b9668637.jpg";